import { Layout } from '@eneco/flows/components';
import { createFlowProvider } from '@eneco/flows/utils';

import { FlowContextServiceGemak } from './context';
import { actions, initialContext, routes } from './ServiceGemakFlow.config';

const { Provider, Navigation, Router } = createFlowProvider<FlowContextServiceGemak>({
  routes,
  actions,
  initialContext,
});

const Flow = () => (
  <Provider>
    <Layout>
      <Layout.Header>
        <Navigation componentName="ServiceGemakFlowNavigation" />
      </Layout.Header>
      <Router />
    </Layout>
  </Provider>
);

export default Flow;
